import APIClient from '@/shared/http/clients/api'

const resourceName = 'termoaceite'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const EditaTermoAceite = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}/EditaTermoAceite`, data, config)
const TermoByid = (companyID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/TermoByid/${companyID}`, data, config)
const FuncionarioImpossibilitado = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/FuncionarioImpossibilitado`, data, config)
const GetAll = (companyID, type, filters = '', data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/empresa/${companyID}/tipo/${type}/list${filters}`, data, config)
const GetAllPaging = (companyID, type, limit, index, filters = '', config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/empresa/${companyID}/tipo/${type}/list?limit=${limit}&index=${index}${filters}`, config)
const GetAllWithApproved = (companyID, type, filters = '', data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/empresa/${companyID}/tipo/${type}/list/all${filters}`, data, config)
const GetAlllWithApprovedPaging = (companyID, type, limit, index, filters = '', config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/empresa/${companyID}/tipo/${type}/list/all?limit=${limit}&index=${index}${filters}`, config)
const GetExist = (companyID, type, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/empresa/${companyID}/tipo/${type}`, data, config)
const GetById = (id, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/${id}`, config)
const SetApproved = (data, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/approved`, data, config)
const SetApprovedDiretoria = (data, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/approvedDiretoria`, data, config)
const SetDisapproved = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/disapproved`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}`, data, config)
const GetAllByDiretoria = (id, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllByDiretoria/${id}`, data, config)
const GetLogById = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetLogById/${id}`, data, config)
const GetAllByDiretoriaPaging = (id, limit, index, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllByDiretoria/${id}?limit=${limit}&index=${index}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIBusinessCommon}/${resourceName}/${id}`, config)
const ExcluirAdiantamentoViagem = (companyId, id, config = {}) => APIClient.delete(`${APIBusinessCommon}/${resourceName}/ExcluirAdiantamentoViagem/${companyId}/${id}`, config)
const GetAllByCompanyAndAuthoPaging = (companyID, type, limit, index, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetAllByCompanyAndAutho/${companyID}/tipo/${type}?limit=${limit}&index=${index}`, data, config)
const GetAllSearching = (companyID, type, data, limit, index, filters = '', config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetAllSearching/${companyID}/tipo/${type}`, data, config)
const print = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/print`, data, config)
const printVenda = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/printVenda`, data, config)
const printByTermo = (termoid, tipo, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/printbytermo/${termoid}/${tipo}`, data, config)
const GetEnumSituacao = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetStatuTermoAceite`, data, config)
const NextStatus = (id, data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}/NextStatus/${id}`, data, config)
const NextStatusDisaprove = (id, data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}/NextStatusDisaprove/${id}`, data, config)
const exportExcel = (data = [], config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/export`, data, config)
const GetAllTermTravel = (companyId, limit, index, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllTermTravel/${companyId}?limit=${limit}&index=${index}`, data, config)
const SaveTermoAceite = (empresaid, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/SaveTermoAceite/${empresaid}`, data, config)
const GetSignature = (termoAceiteId, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetSignature/${termoAceiteId}`, data, config)
const GetAssinaturaVendaBaixada = (termoAceiteId, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetAssinaturaVendaBaixada/${termoAceiteId}`, data, config)
const GeteAcessosClaimStatus = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GeteAcessosClaimStatus`, data, config)
const ExportExcelTermo = (name, data = [], config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/ExportExcelTermo/${name}`, data, config)
const sendSign = (termoId, AnexoTipo, data = [], config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/sendsign/${termoId}/${AnexoTipo}`, data, {
  ...config,
  transformRequest: [(d, headers) => {
    delete headers['Content-Type']
    return d
  }]
})
const GetTotalDiretoria = (data = [], config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetTotalDiretoria`, data, config)
const GetAllHistoric = (funcionarioId, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetAllHistoric/${funcionarioId}`, data, config)
const ImportExcelByIds = (data = [], config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/ImportExcelByIds`, data, config)

const AcceptanceTermRepository = {
  GetAll,
  EditaTermoAceite,
  GetAllPaging,
  TermoByid,
  GetAllWithApproved,
  GetAlllWithApprovedPaging,
  GetExist,
  GetById,
  ImportExcelByIds,
  SetApproved,
  SetDisapproved,
  SetApprovedDiretoria,
  Create,
  Update,
  GetAllSearching,
  Delete,
  ExcluirAdiantamentoViagem,
  GetAllByDiretoria,
  GetAllByCompanyAndAuthoPaging,
  GetAllByDiretoriaPaging,
  print,
  printVenda,
  GetEnumSituacao,
  exportExcel,
  GetAllTermTravel,
  NextStatus,
  NextStatusDisaprove,
  SaveTermoAceite,
  GetSignature,
  GetAssinaturaVendaBaixada,
  GeteAcessosClaimStatus,
  ExportExcelTermo,
  printByTermo,
  sendSign,
  GetTotalDiretoria,
  GetAllHistoric,
  FuncionarioImpossibilitado,
  GetLogById
}

export default AcceptanceTermRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/acceptanceterm.js